Ext.define('SA.view.sidebar.location.LocationsSidebar', {
    alias: 'widget.locations-sidebar',
    extend: 'SA.view.SimpleContainer',

    items: [
        {
            xtype: 'location-search-field',
            cls: 'sa-sidebar-search-field',
            itemId: 'sidebar-location-search-field'
        }, {
            xtype: 'sidebar-section-header',
            autoEl: 'button',
            cls: 'sa-sidebar-section-header-expandable',
            collapsed: true,
            html: 'Custom Locations <span class="sa-sidebar-section-header-inner">Show</span>',
            itemId: 'sidebarLocationMoreBtn',

            handler() {
                var collapsed = this.collapsed = !this.collapsed;

                this.el.down('.sa-sidebar-section-header-inner', true).innerHTML = collapsed ? 'Show' : 'Hide';

                this.up('locations-sidebar').customLocationsList.setVisible(!collapsed);
            }
        }, {
            xtype: 'custom-locations-list',
            hidden: true
        }
    ],

    initComponent() {
        this.callParent();

        this.customLocationsList = this.down('custom-locations-list');
        this.searchField = this.down('#sidebar-location-search-field');

        this.searchField.on('select', this.onLocationSelect, this);

        this.searchFieldInertController = SA.view.SearchFieldInertMaskController.create({field: this.searchField});
    },

    afterHide() {
        this.callParent(arguments);

        this.clearSearchField();
    },

    clearSearchField() {
        this.searchField.setValue('');
    },

    onLocationSelect(field, locationSeries) {
        this.useLocation(locationSeries);
    },

    setProjectView(view) {
        var oldProject = this.projectView && this.projectView.getProject(),
            newProject = view.getProject();

        this.projectView = view;
        this.country = newProject.getCountry();

        this.updateSelectedLocations();

        Ext.destroy(this.viewLocationsListener);

        this.viewLocationsListener = view.on({
            'change:location': this.updateSelectedLocations,

            destroyable: true,
            scope: this
        });

        if (newProject !== oldProject) {
            this.clearSearchField();
        }

        this.searchField.setView(view);
    },

    setUseHandler(useHandler) {
        this.useHandler = useHandler;
    },

    updateSelectedLocations() {
        var searchField = this.searchField,
            customLocationsList = this.customLocationsList,
            locations = this.projectView.getLocations();

        searchField.setSelected(locations);
        customLocationsList.setSelectedLocations(locations);
    },

    useLocation(location) {
        if (this.useHandler) {
            this.useHandler(location);
            return;
        }

        var view = this.projectView,
            project = view.getProject(),
            hadLocations = project.hasLocations();

        view.addLocation(location);

        if (!hadLocations && project.hasLocations()) {
            project.autoCreateViews(['comparison', 'map', 'ranking', 'quickReport', 'businessSearchTable']);
        }

        view.save();

        SA.data.RecentLocations.add(location);
        SA.Sidebar.fireUseItem('use:location', location);
    }
});
